import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSave,
  faBarcode,
  faArrowLeft,
  faPlusCircle,
  faClipboardList,
  faPowerOff,
  faList
} from "@fortawesome/free-solid-svg-icons";
import { logout } from "../../backend";
import { version } from "../../../package.json";

export default function() {
  const { children, routes } = this.props;
  const { header, fullscreen, type = { id: 0 }} = this.state;

  return (
    <div className="container page">
      {!fullscreen && (
        <div className="page-header">
          <span onClick={this._back}>
            <FontAwesomeIcon icon={faArrowLeft} size="1x" />
          </span>
          <div className="header-title">
            {header}
          </div>
          <small>v{version}</small>
          <span className="btn_logout"
            onClick={async () => {
              await logout();
              this._navigate("/login")();
            }}
          >
            <FontAwesomeIcon icon={faPowerOff} size="1x" />
          </span>
        </div>
      )}
      <div className="page-body">
        {!fullscreen && <div className="clear-fix-top" />}
        {children}
        {!fullscreen && <div className="clear-fix-bottom" />}
      </div>
      {!fullscreen && (
        <div className="page-footer">
          {type.id !== 3 ? (
            <div className="icon" onClick={this._navigate(routes.machines)}>
            <FontAwesomeIcon size="2x" icon={faList} />
            <span>Machines</span>
          </div>
          ) : null}
          <div className="icon" onClick={this._navigate(routes.stores)}>
            <FontAwesomeIcon size="2x" icon={faClipboardList} />
            <span>Store Reports</span>
          </div>
          {/* {(type.id === 3) ? ( */}
            <div id="add_store_report" className={ type.id === 4 ? "icon add_store_report hide" : "icon add_store_report" } onClick={this._navigate(routes.create)}>
              <FontAwesomeIcon size="2x" icon={faPlusCircle} />
              <span>Add Store Report</span>
            </div>
          {/* ) : null} */}
          {/* <div className="icon" onClick={this._navigate(routes.savedForms)}>
            <FontAwesomeIcon size="2x" icon={faSave} />
            <span>Saved Forms</span>
          </div> */}
          <div className="icon" onClick={this._navigate(routes.barcodeScanner)}>
            <FontAwesomeIcon size="2x" icon={faBarcode} />
            <span>Scanner</span>
          </div>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/page/view.js